import type { Dict } from '../i18n';

/* English text is the key (see ../i18n.ts). A new UI text needs an entry in de.ts, uk.ts and pl.ts. */
const dict: Dict = {
  "Loading…": "Ładowanie…",
  "Switch project": "Zmień projekt",
  "All Projects": "Wszystkie projekty",
  "Search": "Szukaj",
  "No matching project": "Brak pasującego projektu",
  "Switch team": "Zmień zespół",
  "No team": "Brak zespołu",
  "All teams…": "Wszystkie zespoły…",
  "Recently visited:": "Ostatnio odwiedzone:",
  "Teams": "Zespoły",
  "My View": "Mój widok",
  "View Issues": "Zgłoszenia",
  "Report Issue": "Nowe zgłoszenie",
  "Change Log": "Lista zmian",
  "Roadmap": "Plan rozwoju",
  "Summary": "Tytuł",
  "Summary|page": "Podsumowanie",
  "Manage": "Zarządzanie",
  "My Account": "Moje konto",
  "RSS": "RSS",
  "Logout": "Wyloguj",
  "Expand": "Rozwiń",
  "Collapse": "Zwiń",
  "Expand sidebar": "Rozwiń panel boczny",
  "Collapse sidebar": "Zwiń panel boczny",
  "Scroll to top": "Przewiń na górę",
  "Scroll to bottom": "Przewiń na dół",
  "Access level {level}": "Poziom dostępu: {level}",
  "Access level {level} in {project}": "Poziom dostępu w {project}: {level}",
  "Issue #": "Zgłoszenie nr",
  "Jump to issue": "Przejdź do zgłoszenia",
  "Page not found": "Nie znaleziono strony",
  "Back to My View": "Wróć do Mojego widoku",
  "just now": "przed chwilą",
  "yesterday": "wczoraj",
  "Unassigned": "Nieprzypisane",
  "Feature": "Funkcja",
  "Task": "Zadanie",
  "Bug": "Błąd",
  "Priority": "Priorytet",
  "Close": "Zamknij",
  "Type": "Typ",
  "Key": "Nr",
  "private": "prywatne",
  "pinned": "przypięte",
  "Assignee": "Przypisany",
  "Reporter": "Zgłaszający",
  "P": "P",
  "Status": "Status",
  "Comments": "Komentarze",
  "Attachments": "Załączniki",
  "Updated": "Zaktualizowano",
  "Select all": "Zaznacz wszystko",
  "Select {id}": "Zaznacz {id}",
  "No issues match your filters.": "Brak zgłoszeń pasujących do filtrów.",
  "None": "Brak",
  "Could not load: {error}": "Nie udało się wczytać: {error}",
  "E-mail on New": "E-mail o nowym zgłoszeniu",
  "E-mail on Change of Handler": "E-mail o zmianie przypisanego",
  "E-mail on Feedback": "E-mail o prośbie o odpowiedź",
  "E-mail on Resolved": "E-mail o rozwiązaniu",
  "E-mail on Closed": "E-mail o zamknięciu",
  "E-mail on Reopened": "E-mail o ponownym otwarciu",
  "E-mail on Note Added": "E-mail o nowej notatce",
  "E-mail on Status Change": "E-mail o zmianie statusu",
  "E-mail on Priority Change": "E-mail o zmianie priorytetu",
  "The new passwords do not match.": "Nowe hasła nie są zgodne.",
  "Account updated.": "Konto zaktualizowane.",
  "Preferences saved.": "Ustawienia zapisane.",
  "Edit Account": "Edytuj konto",
  "Username": "Nazwa użytkownika",
  "Access Level": "Poziom dostępu",
  "Real Name": "Imię i nazwisko",
  "E-mail": "E-mail",
  "Current Password": "Obecne hasło",
  "New Password": "Nowe hasło",
  "Confirm Password": "Potwierdź hasło",
  "Update User": "Zaktualizuj",
  "Member since {date} · last visit {visit}": "Członek od {date} · ostatnia wizyta {visit}",
  "Assigned Projects": "Przypisane projekty",
  "Preferences": "Ustawienia",
  "Color issue rows by status": "Koloruj wiersze zgłoszeń według statusu",
  "Dark mode": "Tryb ciemny",
  "Close image preview": "Zamknij podgląd obrazu",
  "Language": "Język",
  "Default Project": "Domyślny projekt",
  "Notes Sort Order": "Kolejność notatek",
  "Ascending (oldest first)": "Rosnąco (najstarsze najpierw)",
  "Descending (newest first)": "Malejąco (najnowsze najpierw)",
  "Update Prefs": "Zapisz ustawienia",
  "Sign-up is by invitation only. Ask a team administrator to invite you.": "Rejestracja tylko z zaproszeniem. Poproś administratora zespołu o zaproszenie.",
  "Back to login": "Wróć do logowania",
  "Join {team}": "Dołącz do {team}",
  "Create your account": "Utwórz konto",
  "Create an account to accept the invitation.": "Utwórz konto, aby przyjąć zaproszenie.",
  "(optional)": "(opcjonalnie)",
  "(at least 8 characters)": "(co najmniej 8 znaków)",
  "Team name": "Nazwa zespołu",
  "{name}'s team": "Zespół {name}",
  "e.g. Acme": "np. Acme",
  "Creating…": "Tworzenie…",
  "Create account and join": "Utwórz konto i dołącz",
  "Create account": "Utwórz konto",
  "Already have an account?": "Masz już konto?",
  "Log in": "Zaloguj się",
  "Go to login": "Przejdź do logowania",
  "This invitation to \"{team}\" has expired or was already used. Ask for a new one.": "Zaproszenie do „{team}\" wygasło lub zostało już użyte. Poproś o nowe.",
  "{who} invited you to the team \"{team}\". You're logged in as {user}.": "{who} zaprasza Cię do zespołu „{team}\". Jesteś zalogowany jako {user}.",
  "A team administrator": "Administrator zespołu",
  "Joining…": "Dołączanie…",
  "Join the team": "Dołącz do zespołu",
  "Not you?": "To nie Ty?",
  "Log out": "Wyloguj się",
  "and use another account.": "i użyj innego konta.",
  "Check your e-mail": "Sprawdź pocztę",
  "If an account uses this address, we sent it a link to choose a new password. The link is valid for 1 hour.": "Jeśli ten adres należy do konta, wysłaliśmy na niego link do ustawienia nowego hasła. Link jest ważny 1 godzinę.",
  "Reset password": "Resetowanie hasła",
  "Enter the e-mail address of your account.": "Podaj adres e-mail swojego konta.",
  "Sending…": "Wysyłanie…",
  "Send reset link": "Wyślij link",
  "Choose a new password": "Ustaw nowe hasło",
  "The passwords do not match.": "Hasła nie są zgodne.",
  "Repeat new password": "Powtórz nowe hasło",
  "Saving…": "Zapisywanie…",
  "Set password": "Ustaw hasło",
  "Choose your password": "Ustaw swoje hasło",
  "Welcome, {name}! Your account was created with a temporary password. Please choose your own before you continue.": "Witaj, {name}! Twoje konto utworzono z hasłem tymczasowym. Ustaw własne hasło, zanim przejdziesz dalej.",
  "Temporary password": "Hasło tymczasowe",
  "Save and continue": "Zapisz i kontynuuj",
  "drag cards between columns to change status": "przeciągaj karty między kolumnami, aby zmienić status",
  "Search this board": "Szukaj na tablicy",
  "Only my issues": "Tylko moje zgłoszenia",
  "Show closed (30 days)": "Pokaż zamknięte (30 dni)",
  "Clear filters": "Wyczyść filtry",
  "Loading board…": "Ładowanie tablicy…",
  "Showing the first {shown} of {total} issues. Pick a project to narrow the board.": "Wyświetlono pierwsze {shown} z {total} zgłoszeń. Wybierz projekt, aby zawęzić tablicę.",
  "Drop issues here": "Upuść zgłoszenia tutaj",
  "Send a Reminder": "Wyślij przypomnienie",
  "Jump to Notes": "Przejdź do notatek",
  "Jump to History": "Przejdź do historii",
  "Previous issue in the list": "Poprzednie zgłoszenie na liście",
  "Next issue in the list": "Następne zgłoszenie na liście",
  "ID": "ID",
  "Project": "Projekt",
  "Category": "Kategoria",
  "View Status": "Widoczność",
  "public": "publiczne",
  "Date Submitted": "Data zgłoszenia",
  "Last Update": "Ostatnia zmiana",
  "Assigned To": "Przypisane do",
  "Due Date": "Termin",
  "Severity": "Waga",
  "Reproducibility": "Powtarzalność",
  "Resolution": "Rozwiązanie",
  "Duplicate of": "Duplikat",
  "Product Version": "Wersja produktu",
  "Target Version": "Wersja docelowa",
  "Fixed in Version": "Naprawiono w wersji",
  "Platform": "Platforma",
  "OS": "System",
  "OS Version": "Wersja systemu",
  "Product Build": "Kompilacja produktu",
  "Projection": "Zakres prac",
  "ETA": "Szac. czas",
  "Description": "Opis",
  "Steps To Reproduce": "Kroki do odtworzenia",
  "Additional Information": "Dodatkowe informacje",
  "Tags": "Tagi",
  "Edit": "Edytuj",
  "Assign To:": "Przypisz do:",
  "Assign to": "Przypisz do",
  "[Nobody]": "[Nikt]",
  "[Myself]": "[Ja]",
  "[Reporter]": "[Zgłaszający]",
  "Assign to me": "Przypisz do mnie",
  "Change Status To:": "Zmień status na:",
  "New status": "Nowy status",
  "End Monitor": "Przestań obserwować",
  "Monitor": "Obserwuj",
  "Unstick": "Odepnij",
  "Stick": "Przypnij",
  "Clone": "Klonuj",
  "Move": "Przenieś",
  "Delete issue {id} permanently? This cannot be undone.": "Usunąć zgłoszenie {id} na stałe? Tej operacji nie można cofnąć.",
  "Delete": "Usuń",
  "Move issue {id}": "Przenieś zgłoszenie {id}",
  "Move to project": "Przenieś do projektu",
  "Select a project…": "Wybierz projekt…",
  "If the category doesn't exist in the target project, it will be cleared.": "Jeśli w projekcie docelowym nie ma tej kategorii, zostanie wyczyszczona.",
  "Cancel": "Anuluj",
  "Move Issues": "Przenieś zgłoszenia",
  "To (Ctrl+click for several)": "Do (Ctrl+klik dla kilku)",
  "Reminder": "Przypomnienie",
  "Please have a look at this issue…": "Proszę spojrzeć na to zgłoszenie…",
  "The recipients get an e-mail, and the reminder is recorded as a note on the issue.": "Odbiorcy dostaną e-mail, a przypomnienie zostanie zapisane jako notatka w zgłoszeniu.",
  "Send": "Wyślij",
  "Change status of issue {id}": "Zmiana statusu zgłoszenia {id}",
  "Duplicate of issue #": "Duplikat zgłoszenia nr",
  "The resolution will be set to \"reopened\".": "Rozwiązanie zostanie ustawione na „ponownie otwarte\".",
  "Set status: {status}": "Ustaw status: {status}",
  "Add a note (optional)": "Dodaj notatkę (opcjonalnie)",
  "Private": "Prywatne",
  "Time tracking (HH:MM)": "Czas pracy (GG:MM)",
  "Detach": "Odłącz",
  "No tags attached.": "Brak tagów.",
  "(Separate by \",\")": "(Oddzielaj „,\")",
  "Attach tags": "Dodaj tagi",
  "Existing tags": "Istniejące tagi",
  "Attach": "Dodaj",
  "The file content was not imported from Mantis": "Treść pliku nie została zaimportowana z Mantis",
  "file missing": "brak pliku",
  "Delete {file}?": "Usunąć {file}?",
  "Attached Files": "Załączone pliki",
  "Updating Issue Information": "Edycja zgłoszenia",
  "(none)": "(brak)",
  "Update Information": "Zapisz zmiany",
  "Relationships": "Powiązania",
  "Current issue": "To zgłoszenie",
  "Add": "Dodaj",
  "Delete relationship": "Usuń powiązanie",
  "Delete this relationship?": "Usunąć to powiązanie?",
  "Users monitoring this issue": "Obserwujący to zgłoszenie",
  "Remove": "Usuń",
  "There are no users monitoring this issue.": "Nikt nie obserwuje tego zgłoszenia.",
  "Add Note": "Dodaj notatkę",
  "Add a note… (drop files here or paste a screenshot to attach them)": "Dodaj notatkę… (upuść pliki tutaj lub wklej zrzut ekranu)",
  "Attach files": "Załącz pliki",
  "Activities": "Aktywność",
  "Time tracking: {time}": "Czas pracy: {time}",
  "There are no notes attached to this issue.": "To zgłoszenie nie ma notatek.",
  "reminder": "przypomnienie",
  "edited {when}": "edytowano {when}",
  "Save": "Zapisz",
  "Delete this note?": "Usunąć tę notatkę?",
  "Make Public": "Upublicznij",
  "Make Private": "Ustaw jako prywatne",
  "Sticky Issue": "Przypięte",
  "Duplicate ID": "ID duplikatu",
  "New Issue": "Nowe zgłoszenie",
  "Note Added: {v}": "Dodano notatkę: {v}",
  "Note Edited: {v}": "Edytowano notatkę: {v}",
  "Note Deleted: {v}": "Usunięto notatkę: {v}",
  "Description Updated": "Zmieniono opis",
  "Additional Information Updated": "Zmieniono dodatkowe informacje",
  "Steps to Reproduce Updated": "Zmieniono kroki do odtworzenia",
  "File Added: {v}": "Dodano plik: {v}",
  "File Deleted: {v}": "Usunięto plik: {v}",
  "Note View State: {v}": "Widoczność notatki: {v}",
  "Issue Monitored: {v}": "Rozpoczęto obserwację: {v}",
  "Issue End Monitor: {v}": "Zakończono obserwację: {v}",
  "Relationship added": "Dodano powiązanie",
  "Relationship deleted": "Usunięto powiązanie",
  "Issue cloned": "Sklonowano zgłoszenie",
  "Issue generated from": "Zgłoszenie utworzone z",
  "Tag Attached: {v}": "Dodano tag: {v}",
  "Tag Detached: {v}": "Usunięto tag: {v}",
  "change ({type})": "zmiana ({type})",
  "Issue History": "Historia zgłoszenia",
  "Date Modified": "Data zmiany",
  "Field": "Pole",
  "Change": "Zmiana",
  "List": "Lista",
  "Board": "Tablica",
  "{n} selected": "zaznaczono: {n}",
  "Clear selection": "Wyczyść wybór",
  "No options": "Brak opcji",
  "CSV Export": "Eksport CSV",
  "Search summary, description, notes or #id": "Szukaj w tytule, opisie, notatkach lub #id",
  "[None]": "[Nikt]",
  "Monitored by me": "Obserwowane przeze mnie",
  "Hide status": "Ukryj status",
  "[none]": "[brak]",
  "resolved and above": "rozwiązane i wyżej",
  "closed": "zamknięte",
  "Reset filter ({n})": "Resetuj filtr ({n})",
  "Saved filters": "Zapisane filtry",
  "Saved filters…": "Zapisane filtry…",
  "shared by {user}": "udostępnił {user}",
  "Name for this filter:": "Nazwa filtra:",
  "Share this filter with everyone? (Cancel = only me)": "Udostępnić ten filtr wszystkim? (Anuluj = tylko ja)",
  "Save Current Filter": "Zapisz bieżący filtr",
  "Delete this saved filter?": "Usunąć ten zapisany filtr?",
  "Delete saved filter": "Usuń zapisany filtr",
  "Delete filter…": "Usuń filtr…",
  "Viewing Issues ({from} - {to} / {total})": "Zgłoszenia ({from} - {to} / {total})",
  "updating…": "aktualizowanie…",
  "Per page": "Na stronie",
  "{ok} updated, {failed} failed: ": "zaktualizowano: {ok}, błędy: {failed}: ",
  "choose…": "wybierz…",
  "choose project…": "wybierz projekt…",
  "select a project first": "najpierw wybierz projekt",
  "version": "wersja",
  "Assign": "Przypisz",
  "Update Status": "Zmień status",
  "Resolve": "Rozwiąż",
  "Update Priority": "Zmień priorytet",
  "Update Category": "Zmień kategorię",
  "Update Target Version": "Zmień wersję docelową",
  "Update Fixed in Version": "Zmień „Naprawiono w wersji\"",
  "Update View Status": "Zmień widoczność",
  "Note text (required)": "Treść notatki (wymagana)",
  "Optional note": "Notatka (opcjonalnie)",
  "OK": "OK",
  "Log in to your account.": "Zaloguj się na swoje konto.",
  "Your password was changed. Log in with the new one.": "Hasło zostało zmienione. Zaloguj się nowym hasłem.",
  "Username or e-mail": "Nazwa użytkownika lub e-mail",
  "Password": "Hasło",
  "Logging in…": "Logowanie…",
  "Forgot password?": "Nie pamiętasz hasła?",
  "New here?": "Jesteś tu pierwszy raz?",
  "Create an account": "Utwórz konto",
  "Team": "Zespół",
  "Projects": "Projekty",
  "Custom Fields": "Pola niestandardowe",
  "New project name": "Nazwa nowego projektu",
  "Create Project": "Utwórz projekt",
  "Create your team's first project to start tracking issues.": "Utwórz pierwszy projekt zespołu, aby zacząć śledzić zgłoszenia.",
  "Name": "Nazwa",
  "Parent": "Nadrzędny",
  "Enabled": "Włączony",
  "Issues": "Zgłoszenia",
  "read-only": "tylko do odczytu",
  "yes": "tak",
  "no": "nie",
  "« Projects": "« Projekty",
  "Edit Project: {name}": "Edycja projektu: {name}",
  "Project Name": "Nazwa projektu",
  "Inherit global categories": "Dziedzicz kategorie globalne",
  "Subproject of": "Podprojekt projektu",
  "Update Project": "Zapisz projekt",
  "Categories": "Kategorie",
  "[global]": "[globalna]",
  "Auto-assign new issues in this category to": "Automatycznie przypisuj nowe zgłoszenia tej kategorii do",
  "(no default assignee)": "(brak domyślnego przypisanego)",
  "Rename category": "Zmień nazwę kategorii",
  "Rename": "Zmień nazwę",
  "Delete category {name}?": "Usunąć kategorię {name}?",
  "New category": "Nowa kategoria",
  "Add Category": "Dodaj kategorię",
  "Versions": "Wersje",
  "Version": "Wersja",
  "Released": "Wydana",
  "Obsolete": "Przestarzała",
  "Date": "Data",
  "Rename version (also updates issues)": "Zmień nazwę wersji (zmieni też zgłoszenia)",
  "Delete version {name}?": "Usunąć wersję {name}?",
  "New version": "Nowa wersja",
  "released": "wydana",
  "Add Version": "Dodaj wersję",
  "Project Members (access overrides)": "Członkowie projektu (indywidualne uprawnienia)",
  "No per-project access overrides. Public projects use each member's team access level.": "Brak indywidualnych uprawnień w projekcie. Projekty publiczne używają poziomu dostępu członka w zespole.",
  "user…": "użytkownik…",
  "Add / Update": "Dodaj / zmień",
  "No custom fields defined.": "Brak pól niestandardowych.",
  "Display on report": "Pokaż przy zgłaszaniu",
  "Display on update": "Pokaż przy edycji",
  "Display on resolve": "Pokaż przy rozwiązywaniu",
  "Display on close": "Pokaż przy zamykaniu",
  "Required on report": "Wymagane przy zgłaszaniu",
  "Required on update": "Wymagane przy edycji",
  "Required on resolve": "Wymagane przy rozwiązywaniu",
  "Required on close": "Wymagane przy zamykaniu",
  "Add to filters": "Dodaj do filtrów",
  "New Custom Field": "Nowe pole niestandardowe",
  "Possible values (a|b|c)": "Możliwe wartości (a|b|c)",
  "Default value": "Wartość domyślna",
  "Regular expression": "Wyrażenie regularne",
  "Read access": "Dostęp do odczytu",
  "Write access": "Dostęp do zapisu",
  "Min. length": "Min. długość",
  "Max. length": "Maks. długość",
  "Linked projects": "Powiązane projekty",
  "Possible values": "Możliwe wartości",
  "Delete custom field {name} and all its values?": "Usunąć pole {name} wraz ze wszystkimi wartościami?",
  "Rename team": "Zmień nazwę zespołu",
  "Joined": "Dołączył",
  "Last Visit": "Ostatnia wizyta",
  "you": "Ty",
  "Has not replaced the temporary password yet": "Nie zmienił jeszcze hasła tymczasowego",
  "temporary password": "hasło tymczasowe",
  "Leave \"{team}\"?": "Opuścić „{team}\"?",
  "Remove {user} from the team?": "Usunąć {user} z zespołu?",
  "Leave": "Opuść",
  "The access level applies to every project of the team; a project's members list can raise or lower it for that project. Administrators manage the team and its projects.": "Poziom dostępu obowiązuje we wszystkich projektach zespołu; na liście członków projektu można go podnieść lub obniżyć dla tego projektu. Administratorzy zarządzają zespołem i jego projektami.",
  "Invite people": "Zaproś osoby",
  "name@company.com": "imie@firma.pl",
  "Send invitation": "Wyślij zaproszenie",
  "Invitation sent to {email}. If the e-mail doesn't arrive, send them this link:": "Zaproszenie wysłano na {email}. Jeśli e-mail nie dotrze, wyślij ten link:",
  "Pending invitation": "Oczekujące zaproszenie",
  "Invited by": "Zaprosił",
  "Expires": "Wygasa",
  "Revoke": "Wycofaj",
  "Copied": "Skopiowano",
  "Copy": "Kopiuj",
  "Back to projects": "Wróć do projektów",
  "Other teams": "Inne zespoły",
  "Assigned to Me (Unresolved)": "Przypisane do mnie (nierozwiązane)",
  "Reported by Me": "Zgłoszone przeze mnie",
  "Resolved": "Rozwiązane",
  "Recently Modified": "Ostatnio zmienione",
  "Monitored by Me": "Obserwowane przeze mnie",
  "Nothing here.": "Nic tu nie ma.",
  "View all {n} →": "Pokaż wszystkie ({n}) →",
  "has been reported.": "zostało zgłoszone.",
  "Required fields are marked with an asterisk": "Pola wymagane oznaczono gwiazdką",
  "Select a project": "Wybierz projekt",
  "Issue type": "Typ zgłoszenia",
  "Component (category)": "Komponent (kategoria)",
  "Select…": "Wybierz…",
  "global": "globalna",
  "What happened? What did you expect?": "Co się stało? Czego się spodziewałeś?",
  "Automatic / unassigned": "Automatycznie / nieprzypisane",
  "Labels": "Etykiety",
  "label1, label2": "etykieta1, etykieta2",
  "Affects version": "Dotyczy wersji",
  "Fix version (target)": "Wersja docelowa",
  "Fewer fields": "Mniej pól",
  "More fields (steps, environment, visibility)": "Więcej pól (kroki, środowisko, widoczność)",
  "Steps to reproduce": "Kroki do odtworzenia",
  "Additional information": "Dodatkowe informacje",
  "Visibility": "Widoczność",
  "Public": "Publiczne",
  "Build": "Kompilacja",
  "OS version": "Wersja systemu",
  "Report Stay (report another issue)": "Zostań (zgłoś kolejne)",
  "Submitting…": "Wysyłanie…",
  "Submit Issue": "Wyślij zgłoszenie",
  "Report Issue (clone of {id})": "Nowe zgłoszenie (klon {id})",
  "No unreleased versions with planned issues.": "Brak niewydanych wersji z zaplanowanymi zgłoszeniami.",
  "(scheduled {date})": "(planowana na {date})",
  "View issues": "Pokaż zgłoszenia",
  "{resolved} of {total} resolved": "rozwiązano {resolved} z {total}",
  "No released versions.": "Brak wydanych wersji.",
  "(released {date})": "(wydana {date})",
  "No issues.": "Brak zgłoszeń.",
  "By Status": "Według statusu",
  "By Severity": "Według wagi",
  "open": "otwarte",
  "total": "razem",
  "By Project": "Według projektu",
  "By Assignee": "Według przypisanego",
  "resolved": "rozwiązane",
  "(unassigned)": "(nieprzypisane)",
  "Search teams": "Szukaj zespołów",
  "You're not in a team yet. Create one below, or open the invitation link someone sent you.": "Nie należysz jeszcze do zespołu. Utwórz go poniżej lub otwórz link z zaproszeniem, który otrzymałeś.",
  "Open {team}": "Otwórz {team}",
  "More options": "Więcej opcji",
  "Open team": "Otwórz zespół",
  "Members & invitations": "Członkowie i zaproszenia",
  "Leave the team \"{team}\"? You lose access to its projects.": "Opuścić zespół „{team}\"? Stracisz dostęp do jego projektów.",
  "Leave team": "Opuść zespół",
  "Create a team": "Utwórz zespół",
  "e.g. Mobile squad": "np. Zespół mobilny",
  "Create team": "Utwórz zespół",
  "new": "nowe",
  "feedback": "odpowiedź",
  "acknowledged": "uznane",
  "confirmed": "potwierdzone",
  "assigned": "przypisane",
  "none": "brak",
  "low": "niski",
  "normal": "normalny",
  "high": "wysoki",
  "urgent": "pilny",
  "immediate": "natychmiastowy",
  "feature": "nowa funkcja",
  "trivial": "trywialny",
  "text": "tekst",
  "tweak": "poprawka",
  "minor": "drobny",
  "major": "poważny",
  "crash": "awaria",
  "block": "blokujący",
  "always": "zawsze",
  "sometimes": "czasami",
  "random": "losowo",
  "have not tried": "nie sprawdzano",
  "unable to reproduce": "nie da się powtórzyć",
  "N/A": "nd.",
  "fixed": "naprawione",
  "reopened": "ponownie otwarte",
  "not fixable": "nienaprawialne",
  "duplicate": "duplikat",
  "no change required": "zmiana niepotrzebna",
  "suspended": "wstrzymane",
  "minor fix": "drobna poprawka",
  "major rework": "duża przeróbka",
  "redesign": "przeprojektowanie",
  "< 1 day": "< 1 dnia",
  "2-3 days": "2-3 dni",
  "< 1 week": "< 1 tygodnia",
  "< 1 month": "< 1 miesiąca",
  "> 1 month": "> 1 miesiąca",
  "viewer": "obserwator",
  "reporter": "zgłaszający",
  "updater": "aktualizujący",
  "developer": "programista",
  "manager": "kierownik",
  "administrator": "administrator",
  "development": "rozwój",
  "release": "wydanie",
  "stable": "stabilny",
  "obsolete": "przestarzały",
  "duplicate of": "duplikat",
  "related to": "powiązane z",
  "parent of": "nadrzędne dla",
  "child of": "podrzędne dla",
  "has duplicate": "ma duplikat",
  "String": "Tekst",
  "Numeric": "Liczba całkowita",
  "Float": "Liczba dziesiętna",
  "Enumeration": "Wyliczenie",
  "Checkbox": "Pola wyboru",
  "Multiselection list": "Lista wielokrotnego wyboru",
  "Radio": "Przyciski opcji",
  "Textarea": "Pole tekstowe",
  "won't fix": "nie będzie naprawiane",
  "Your account may be disabled or the username/password you entered is incorrect.": "Konto może być wyłączone lub nazwa użytkownika/hasło są nieprawidłowe.",
  "Too many attempts. Please wait a few minutes and try again.": "Zbyt wiele prób. Odczekaj kilka minut i spróbuj ponownie.",
  "That username is already taken.": "Ta nazwa użytkownika jest już zajęta.",
  "An account with this e-mail address already exists. Log in or reset your password.": "Konto z tym adresem e-mail już istnieje. Zaloguj się lub zresetuj hasło.",
  "Password must have at least 8 characters": "Hasło musi mieć co najmniej 8 znaków",
  "Username must have at least 2 characters": "Nazwa użytkownika musi mieć co najmniej 2 znaki",
  "Username may only contain letters, digits and . _ @ + -": "Nazwa użytkownika może zawierać tylko litery, cyfry i . _ @ + -",
  "Invalid e-mail address": "Nieprawidłowy adres e-mail",
  "Team name is required": "Nazwa zespołu jest wymagana",
  "The current password is incorrect.": "Obecne hasło jest nieprawidłowe.",
  "The new password must be different from the current one.": "Nowe hasło musi różnić się od obecnego.",
  "Another account already uses this e-mail address.": "Ten adres e-mail jest już używany przez inne konto.",
  "This invitation is no longer valid. Ask for a new one.": "To zaproszenie jest już nieważne. Poproś o nowe.",
  "This invitation link is not valid.": "Ten link z zaproszeniem jest nieprawidłowy.",
  "This link has expired or was already used. Request a new one.": "Ten link wygasł lub został już użyty. Poproś o nowy.",
  "Sign-up is by invitation only.": "Rejestracja tylko z zaproszeniem.",
  "Please change your password first.": "Najpierw zmień hasło.",
  "Not logged in": "Nie zalogowano",
  "Create or join a team first.": "Najpierw utwórz zespół lub dołącz do niego.",
  "Team administrator access required.": "Wymagane uprawnienia administratora zespołu.",
  "A team needs at least one administrator. Make someone else an administrator first.": "Zespół musi mieć co najmniej jednego administratora. Najpierw nadaj te uprawnienia komuś innemu.",
  "This person is already in the team.": "Ta osoba jest już w zespole.",
  "Only team members can be added to a project. Invite them to the team first.": "Do projektu można dodać tylko członków zespołu. Najpierw zaproś tę osobę do zespołu.",
  "A project with this name already exists.": "Projekt o tej nazwie już istnieje.",
  "Summary is required": "Tytuł jest wymagany",
  "Description is required": "Opis jest wymagany",
  "Category is required": "Kategoria jest wymagana",
  "Internal server error": "Wewnętrzny błąd serwera",
  "Not found": "Nie znaleziono",
  "Access denied": "Odmowa dostępu",
  "Open": "Otwarte",
  "Closed": "Zamknięte",
  "Total": "Razem",
  "{n} minutes ago": {"one": "{n} minutę temu", "few": "{n} minuty temu", "many": "{n} minut temu", "other": "{n} minut temu"},
  "{n} hours ago": {"one": "{n} godzinę temu", "few": "{n} godziny temu", "many": "{n} godzin temu", "other": "{n} godzin temu"},
  "{n} days ago": {"one": "{n} dzień temu", "few": "{n} dni temu", "many": "{n} dni temu", "other": "{n} dni temu"},
  "{n} members": {"one": "{n} członek", "few": "{n} członków", "many": "{n} członków", "other": "{n} członków"},
  "{n} issues updated.": {"one": "Zaktualizowano {n} zgłoszenie.", "few": "Zaktualizowano {n} zgłoszenia.", "many": "Zaktualizowano {n} zgłoszeń.", "other": "Zaktualizowano {n} zgłoszeń."},
  "Delete {n} issues permanently?": {"one": "Usunąć na stałe {n} zgłoszenie?", "few": "Usunąć na stałe {n} zgłoszenia?", "many": "Usunąć na stałe {n} zgłoszeń?", "other": "Usunąć na stałe {n} zgłoszeń?"},
  "{n} projects": {"one": "{n} projekt", "few": "{n} projekty", "many": "{n} projektów", "other": "{n} projektów"},
  "{count} of {n} projects": {"one": "{count} z {n} projektu", "few": "{count} z {n} projektów", "many": "{count} z {n} projektów", "other": "{count} z {n} projektów"},
  "{n} days left": {"one": "został {n} dzień", "few": "zostały {n} dni", "many": "zostało {n} dni", "other": "zostało {n} dni"},
  "{resolved} of {n} issues resolved": {"one": "rozwiązano {resolved} z {n} zgłoszenia", "few": "rozwiązano {resolved} z {n} zgłoszeń", "many": "rozwiązano {resolved} z {n} zgłoszeń", "other": "rozwiązano {resolved} z {n} zgłoszeń"},
  "{n} issues": {"one": "{n} zgłoszenie", "few": "{n} zgłoszenia", "many": "{n} zgłoszeń", "other": "{n} zgłoszeń"},
  "Import": "Import",
  "API": "API",
  "Issue created": "Utworzono zgłoszenie",
  "Issue changed (status, assignee, fields)": "Zmieniono zgłoszenie (status, przypisany, pola)",
  "Note added (public notes only)": "Dodano notatkę (tylko publiczne)",
  "API keys": "Klucze API",
  "Key name, e.g. Ship": "Nazwa klucza, np. Ship",
  "Read only": "Tylko odczyt",
  "Create key": "Utwórz klucz",
  "Key \"{name}\" created. Copy it now — it is shown only once:": "Utworzono klucz „{name}\". Skopiuj go teraz — jest pokazywany tylko raz:",
  "Requests with a key act as the person who created it, with their rights in this team. Revoke a key when it is no longer needed.": "Żądania z kluczem działają w imieniu osoby, która go utworzyła, z jej uprawnieniami w tym zespole. Unieważnij klucz, gdy nie jest już potrzebny.",
  "Access": "Dostęp",
  "Created by": "Utworzył",
  "Created": "Utworzono",
  "Last used": "Ostatnie użycie",
  "read only": "tylko odczyt",
  "read & write": "odczyt i zapis",
  "revoked": "unieważniony",
  "Revoke the key \"{name}\"? Programs using it stop working.": "Unieważnić klucz „{name}\"? Programy, które go używają, przestaną działać.",
  "HTTP {status} in {ms} ms": "HTTP {status} w {ms} ms",
  "Webhooks (send issues to another system)": "Webhooki (wysyłanie zgłoszeń do innego systemu)",
  "New webhook": "Nowy webhook",
  "Test sent to \"{name}\": {result}": "Wysłano test do „{name}\": {result}",
  "When an issue is created or changed, the server sends a POST request with JSON to the endpoint. Each request carries the header X-BugTracker-Signature: sha256=HMAC(secret, body), so the receiver can check that it came from here.": "Gdy zgłoszenie zostanie utworzone lub zmienione, serwer wysyła żądanie POST z JSON do punktu końcowego. Każde żądanie ma nagłówek X-BugTracker-Signature: sha256=HMAC(secret, body), aby odbiorca mógł sprawdzić, skąd pochodzi.",
  "Endpoint": "Punkt końcowy",
  "Events": "Zdarzenia",
  "Last delivery": "Ostatnie wysłanie",
  "Send test": "Wyślij test",
  "Log": "Dziennik",
  "Delete the webhook \"{name}\"?": "Usunąć webhook „{name}\"?",
  "Webhook \"{name}\" saved. Its signing secret (for checking X-BugTracker-Signature):": "Zapisano webhook „{name}\". Jego sekret podpisu (do sprawdzania X-BugTracker-Signature):",
  "Done": "Gotowe",
  "Edit webhook": "Edytuj webhook",
  "e.g. Ship": "np. Ship",
  "API endpoint (URL)": "Punkt końcowy API (URL)",
  "All projects": "Wszystkie projekty",
  "Extra headers (one per line, e.g. Authorization: Bearer <key of the other system>)": "Dodatkowe nagłówki (jeden na wiersz, np. Authorization: Bearer <klucz innego systemu>)",
  "JSON payload": "Treść JSON",
  "(empty = standard payload with the whole issue)": "(puste = standardowa treść z całym zgłoszeniem)",
  "Placeholders: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} inserts a value as JSON, e.g. {{issue|json}} for the whole issue.": "Symbole: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} wstawia wartość jako JSON, np. {{issue|json}} — całe zgłoszenie.",
  "Insert example": "Wstaw przykład",
  "Preview with the latest issue": "Podgląd z najnowszym zgłoszeniem",
  "Signing secret:": "Sekret podpisu:",
  "Create a new secret? The receiver must be updated.": "Utworzyć nowy sekret? Odbiorcę trzeba będzie zaktualizować.",
  "New secret": "Nowy sekret",
  "Deliveries of \"{name}\"": "Wysyłki „{name}\"",
  "Nothing was sent yet.": "Nic jeszcze nie wysłano.",
  "Time": "Czas",
  "Event": "Zdarzenie",
  "Issue": "Zgłoszenie",
  "Result": "Wynik",
  "Request": "Żądanie",
  "Response": "Odpowiedź",
  "the key: team, user, read-only": "klucz: zespół, użytkownik, tylko odczyt",
  "valid values for status, priority, severity, resolution …": "dozwolone wartości statusu, priorytetu, wagi, rozwiązania …",
  "projects of the team": "projekty zespołu",
  "categories, versions and custom fields of a project": "kategorie, wersje i pola niestandardowe projektu",
  "members of the team": "członkowie zespołu",
  "issues; filters: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (max 500), include=notes": "zgłoszenia; filtry: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (maks. 500), include=notes",
  "one issue with its notes": "jedno zgłoszenie z notatkami",
  "create an issue (JSON)": "utwórz zgłoszenie (JSON)",
  "change an issue; \"note\" adds a note at the same time": "zmień zgłoszenie; „note\" od razu dodaje notatkę",
  "add a note: {\"text\": \"...\", \"private\": false}": "dodaj notatkę: {\"text\": \"...\", \"private\": false}",
  "REST API": "REST API",
  "Base URL:": "Adres bazowy:",
  "send the key as": "klucz wysyłaj jako",
  "or": "lub",
  "Values like status or priority can be given as names (\"high\") or Mantis numbers (40); projects, categories and people by name or id. The SOAP API for Mantis tools stays available at /api/soap/mantisconnect.php.": "Wartości takie jak status czy priorytet można podać nazwą („high\") lub liczbą Mantis (40); projekty, kategorie i osoby nazwą lub id. API SOAP dla narzędzi Mantis pozostaje dostępne pod /api/soap/mantisconnect.php.",
  "The upload was interrupted.": "Przesyłanie zostało przerwane.",
  "Reading the dump": "Odczyt zrzutu",
  "Starting…": "Uruchamianie…",
  "Big databases take a while (about 25 minutes for 20,000 issues). You can leave this page and come back later.": "Duże bazy trwają dłużej (ok. 25 minut na 20 000 zgłoszeń). Możesz opuścić tę stronę i wrócić później.",
  "Importing": "Importowanie",
  "Everything is written in one step at the end; until then the team does not change.": "Wszystko zostanie zapisane w jednym kroku na końcu; do tego czasu zespół się nie zmienia.",
  "The last import failed: {error}": "Ostatni import nie powiódł się: {error}",
  "Import from Mantis": "Import z Mantis",
  "Brings projects, issues with their numbers, notes, history, tags, relationships and people from a MantisBT database into this team. People can be matched with the members of the team; everyone else gets an account that keeps their Mantis password.": "Przenosi projekty, zgłoszenia z ich numerami, notatki, historię, tagi, powiązania i osoby z bazy MantisBT do tego zespołu. Osoby można przypisać do członków zespołu; pozostali dostaną konta z hasłem z Mantis.",
  "Mantis database dump (.sql or .sql.gz)": "Zrzut bazy Mantis (.sql lub .sql.gz)",
  "Make the dump with mysqldump or the phpMyAdmin export (SQL format). The attachment folder can be chosen in the next step.": "Utwórz zrzut przez mysqldump lub eksport phpMyAdmin (format SQL). Folder z załącznikami wybierzesz w następnym kroku.",
  "Uploading the dump": "Przesyłanie zrzutu",
  "Upload and read": "Prześlij i odczytaj",
  "The import did not finish: {error}": "Import nie został ukończony: {error}",
  "What the dump contains": "Zawartość zrzutu",
  "People": "Osoby",
  "Choose who each Mantis user is in this team. \"New account\" creates an account with the Mantis username and password and adds it to the team.": "Wybierz, kim w tym zespole jest każdy użytkownik Mantis. „Nowe konto\" tworzy konto z nazwą i hasłem z Mantis i dodaje je do zespołu.",
  "Mantis user": "Użytkownik Mantis",
  "In this team": "W tym zespole",
  "disabled": "wyłączony",
  "New account": "Nowe konto",
  "Start": "Start",
  "Import into this team": "Importuj do tego zespołu",
  "Cancel this import? The uploaded dump and files are deleted.": "Anulować ten import? Przesłany zrzut i pliki zostaną usunięte.",
  "Cancel import": "Anuluj import",
  "Attachments (optional)": "Załączniki (opcjonalnie)",
  "Mantis kept {n} attachment files on its server disk. Choose that upload folder to bring the files along; without it, the attachments are listed but their files are missing (they can be added with a new import later).": "Mantis trzymał {n} plików załączników na dysku serwera. Wybierz ten folder, aby przenieść pliki; bez niego załączniki będą na liście, ale bez plików (można je dodać później nowym importem).",
  "Files received: {received} of {needed}": "Otrzymane pliki: {received} z {needed}",
  "Mantis upload folder": "Folder załączników Mantis",
  "{found} of the {all} files in the folder belong to this dump.": "{found} z {all} plików w folderze należy do tego zrzutu.",
  "Uploading files": "Przesyłanie plików",
  "Notes": "Notatki",
  "History entries": "Wpisy historii",
  "New projects": "Nowe projekty",
  "Existing projects": "Istniejące projekty",
  "New accounts": "Nowe konta",
  "Matched people": "Przypisane osoby",
  "Attachment files": "Pliki załączników",
  "Replaced issues": "Zastąpione zgłoszenia",
  "Import finished": "Import zakończony",
  "\"{name}\" was imported into the team.": "„{name}\" zaimportowano do zespołu.",
  "Go to the issues": "Przejdź do zgłoszeń",
  "New accounts (they log in with their Mantis password):": "Nowe konta (logowanie hasłem z Mantis):",
  "{n} notes": {"one": "{n} notatka", "few": "{n} notatki", "many": "{n} notatek", "other": "{n} notatek"},
  "{n} people": {"one": "{n} osoba", "few": "{n} osoby", "many": "{n} osób", "other": "{n} osób"},
  "{n} attachments": {"one": "{n} załącznik", "few": "{n} załączniki", "many": "{n} załączników", "other": "{n} załączników"},
  "Replace {n} issues of this team that have the same numbers (their notes and history are replaced too)": {"one": "Zastąp {n} zgłoszenie tego zespołu o tym samym numerze (jego notatki i historia też zostaną zastąpione)", "few": "Zastąp {n} zgłoszenia tego zespołu o tych samych numerach (ich notatki i historia też zostaną zastąpione)", "many": "Zastąp {n} zgłoszeń tego zespołu o tych samych numerach (ich notatki i historia też zostaną zastąpione)", "other": "Zastąp {n} zgłoszeń tego zespołu o tych samych numerach (ich notatki i historia też zostaną zastąpione)"},
  "Upload {n} files": {"one": "Prześlij {n} plik", "few": "Prześlij {n} pliki", "many": "Prześlij {n} plików", "other": "Prześlij {n} plików"},
  "{n} warnings": {"one": "{n} ostrzeżenie", "few": "{n} ostrzeżenia", "many": "{n} ostrzeżeń", "other": "{n} ostrzeżeń"},
  "Give these issues new numbers; references like #123 in texts are updated. The list of new numbers can be downloaded after the import.": "Nadaj tym zgłoszeniom nowe numery; odwołania typu #123 w tekstach zostaną zaktualizowane. Listę nowych numerów można pobrać po imporcie.",
  "Issues with new numbers": "Zgłoszenia z nowymi numerami",
  "Download the list of new issue numbers (CSV)": "Pobierz listę nowych numerów zgłoszeń (CSV)",
  "{n} issue numbers of this dump are already used on this server.": {"one": "{n} numer zgłoszenia z tego zrzutu jest już zajęty na tym serwerze.", "few": "{n} numery zgłoszeń z tego zrzutu są już zajęte na tym serwerze.", "many": "{n} numerów zgłoszeń z tego zrzutu jest już zajętych na tym serwerze.", "other": "{n} numerów zgłoszeń z tego zrzutu jest już zajętych na tym serwerze."},
  "The {n} issues whose numbers other teams use get new numbers.": {"one": "{n} zgłoszenie, którego numer używa inny zespół, dostanie nowy numer.", "few": "{n} zgłoszenia, których numery używają inne zespoły, dostaną nowe numery.", "many": "{n} zgłoszeń, których numery używają inne zespoły, dostanie nowe numery.", "other": "{n} zgłoszeń, których numery używają inne zespoły, dostanie nowe numery."},
  "Type {name} to confirm": "Aby potwierdzić, wpisz {name}",
  "Your password": "Twoje hasło",
  "Delete project": "Usuń projekt",
  "Export team data": "Eksport danych zespołu",
  "Downloads everything of the team as a .tar.gz archive: members, projects, issues with notes, history and relationships (JSON), and optionally the attachment files. Windows, macOS and 7-Zip open it.": "Pobiera wszystkie dane zespołu jako archiwum .tar.gz: członków, projekty, zgłoszenia z notatkami, historią i powiązaniami (JSON), a opcjonalnie także pliki załączników. Otworzysz je w Windows, macOS i 7-Zip.",
  "Include attachment files (can be large)": "Dołącz pliki załączników (archiwum może być duże)",
  "Download export": "Pobierz eksport",
  "Delete team": "Usuń zespół",
  "Delete account": "Usunięcie konta",
  "Delete my account": "Usuń moje konto",
  "Removes your name, e-mail address, password and memberships. Issues and notes you wrote stay in their teams and show \"Deleted user\". This cannot be undone.": "Usuwa Twoje imię i nazwisko, adres e-mail, hasło i członkostwa. Zgłoszenia i notatki, które napisałeś, zostaną w zespołach jako autorstwa „Deleted user”. Tego nie można cofnąć.",
  "You are the only member of {teams}; deleting your account deletes these teams with all their projects and issues.": "Jesteś jedynym członkiem {teams}; usunięcie konta usunie te zespoły ze wszystkimi projektami i zgłoszeniami.",
  "You are the only administrator of {teams}. Make another member an administrator (Manage → Team) or delete the team first.": "Jesteś jedynym administratorem {teams}. Najpierw nadaj uprawnienia administratora innemu członkowi (Zarządzanie → Zespół) albo usuń zespół.",
  "Type the name of the team to confirm.": "Aby potwierdzić, wpisz nazwę zespołu.",
  "The password is incorrect.": "Hasło jest nieprawidłowe.",
  "Type the name of the project to confirm.": "Aby potwierdzić, wpisz nazwę projektu.",
  "This project has subprojects. Delete them or move them to another project first.": "Ten projekt ma podprojekty. Najpierw je usuń albo przenieś do innego projektu.",
  "An import into this team is running. Wait for it to finish or cancel it first.": "Trwa import do tego zespołu. Poczekaj na jego zakończenie albo najpierw go anuluj.",
  "Deletes the project with its {n} issues, their notes, history and attachments. This cannot be undone.": {"one": "Usuwa projekt wraz z {n} zgłoszeniem, jego notatkami, historią i załącznikami. Tego nie można cofnąć.", "few": "Usuwa projekt wraz z {n} zgłoszeniami, ich notatkami, historią i załącznikami. Tego nie można cofnąć.", "many": "Usuwa projekt wraz z {n} zgłoszeniami, ich notatkami, historią i załącznikami. Tego nie można cofnąć.", "other": "Usuwa projekt wraz z {n} zgłoszeniami, ich notatkami, historią i załącznikami. Tego nie można cofnąć."},
  "Deletes the team with its {n} projects, all issues and files, API keys and webhooks. Members lose access; their accounts stay. This cannot be undone, so export the data first if you may need it.": {"one": "Usuwa zespół wraz z {n} projektem, wszystkimi zgłoszeniami i plikami, kluczami API i webhookami. Członkowie stracą dostęp, ale ich konta zostaną. Tego nie można cofnąć, więc najpierw wyeksportuj dane, jeśli mogą się przydać.", "few": "Usuwa zespół wraz z {n} projektami, wszystkimi zgłoszeniami i plikami, kluczami API i webhookami. Członkowie stracą dostęp, ale ich konta zostaną. Tego nie można cofnąć, więc najpierw wyeksportuj dane, jeśli mogą się przydać.", "many": "Usuwa zespół wraz z {n} projektami, wszystkimi zgłoszeniami i plikami, kluczami API i webhookami. Członkowie stracą dostęp, ale ich konta zostaną. Tego nie można cofnąć, więc najpierw wyeksportuj dane, jeśli mogą się przydać.", "other": "Usuwa zespół wraz z {n} projektami, wszystkimi zgłoszeniami i plikami, kluczami API i webhookami. Członkowie stracą dostęp, ale ich konta zostaną. Tego nie można cofnąć, więc najpierw wyeksportuj dane, jeśli mogą się przydać."},
  "A NEW issue has been reported by {user}.": "{user} zgłosił NOWE zgłoszenie.",
  "The issue has been ASSIGNED by {user}.": "{user} PRZYPISAŁ zgłoszenie.",
  "The status of the issue changed from {from} to {to} (by {user}).": "Status zgłoszenia zmienił się z {from} na {to} (zmienił {user}).",
  "A NOTE has been added to this issue by {user}.": "{user} dodał NOTATKĘ do tego zgłoszenia.",
  "The priority of the issue was changed by {user}.": "{user} zmienił priorytet zgłoszenia.",
  "The issue has been UPDATED by {user} ({fields}).": "{user} ZMIENIŁ zgłoszenie ({fields}).",
  "A relationship to issue #{id} was added (by {user}).": "Dodano powiązanie ze zgłoszeniem #{id} (dodał {user}).",
  "Issue ID": "Numer zgłoszenia",
  "(note by {user})": "(notatka od {user})",
  "Reset your {app} password": "Resetowanie hasła {app}",
  "Hello {user},": "Cześć {user},",
  "open this link to choose a new password (valid for 1 hour):": "otwórz ten link, aby ustawić nowe hasło (ważny przez 1 godzinę):",
  "If you didn't ask for this, ignore this e-mail.": "Jeśli to nie Ty o to prosiłeś, zignoruj tę wiadomość.",
  "{user} sent you a reminder regarding this issue:": "{user} wysłał Ci przypomnienie dotyczące tego zgłoszenia:",
  "{user} invited you to the team \"{team}\" on {app}": "{user} zaprasza Cię do zespołu „{team}” w {app}",
  "{user} invited you to join the team \"{team}\" on {app}.": "{user} zaprasza Cię do dołączenia do zespołu „{team}” w {app}.",
  "Hello,": "Cześć,",
  "Accept the invitation (valid for {n} days):": {"one": "Przyjmij zaproszenie (ważne {n} dzień):", "few": "Przyjmij zaproszenie (ważne {n} dni):", "many": "Przyjmij zaproszenie (ważne {n} dni):", "other": "Przyjmij zaproszenie (ważne {n} dni):"},
  "Confirm your e-mail address for {app}": "Potwierdź adres e-mail w {app}",
  "please confirm your e-mail address by opening this link (valid for 7 days):": "potwierdź swój adres e-mail, otwierając ten link (ważny 7 dni):",
  "If you didn't create an account, ignore this e-mail.": "Jeśli nie zakładałeś konta, zignoruj tę wiadomość.",
  "Add an e-mail address to your account first.": "Najpierw dodaj adres e-mail do swojego konta.",
  "Your e-mail address is already confirmed.": "Twój adres e-mail jest już potwierdzony.",
  "Too many e-mails. Please wait an hour and try again.": "Zbyt wiele wiadomości. Odczekaj godzinę i spróbuj ponownie.",
  "This link is for an e-mail address the account no longer uses.": "Ten link dotyczy adresu e-mail, którego konto już nie używa.",
  "Confirm your e-mail address before inviting people. The link is in the e-mail we sent you.": "Potwierdź adres e-mail, zanim zaprosisz innych. Link znajdziesz w wiadomości, którą Ci wysłaliśmy.",
  "Please confirm your e-mail address {email}: open the link in the e-mail we sent you.": "Potwierdź swój adres e-mail {email}: otwórz link z wiadomości, którą Ci wysłaliśmy.",
  "Sent. Check your inbox.": "Wysłano. Sprawdź skrzynkę odbiorczą.",
  "Send the link again": "Wyślij link ponownie",
  "Confirm e-mail address": "Potwierdzenie adresu e-mail",
  "Thank you, your e-mail address is confirmed.": "Dziękujemy, Twój adres e-mail jest potwierdzony.",
  "Continue": "Dalej",
  "Account updated. We sent a link to the new e-mail address to confirm it.": "Konto zaktualizowane. Wysłaliśmy link na nowy adres e-mail, aby go potwierdzić.",
  "Create a project": "Utwórz projekt",
  "Projects hold the issues, with their own categories and versions.": "Projekty zawierają zgłoszenia, z własnymi kategoriami i wersjami.",
  "Report the first issue": "Zgłoś pierwsze zgłoszenie",
  "A bug, a task or an idea: anything the team should work on.": "Błąd, zadanie albo pomysł: wszystko, nad czym zespół ma pracować.",
  "Invite your team": "Zaproś swój zespół",
  "Colleagues get an e-mail with a link to join.": "Współpracownicy dostaną e-mail z linkiem do dołączenia.",
  "Bring your data and tools": "Przenieś dane i podłącz narzędzia",
  "Import a Mantis database, or connect other tools with an API key or webhooks.": "Zaimportuj bazę Mantis albo podłącz inne narzędzia kluczem API lub webhookami.",
  "Get started with {team}": "Pierwsze kroki z {team}",
  "{done} of {total} done": "Zrobione {done} z {total}",
  "Hide": "Ukryj",
  "Just looking around?": "Chcesz się tylko rozejrzeć?",
  "Create a sample project with example issues": "Utwórz przykładowy projekt z przykładowymi zgłoszeniami",
  "(you can delete it later)": "(możesz go później usunąć)",
  "Sample project": "Przykładowy projekt",
  "Example issues to try things out. Delete this project when you no longer need it.": "Przykładowe zgłoszenia do wypróbowania. Usuń ten projekt, gdy nie będzie już potrzebny.",
  "General": "Ogólne",
  "The \"Log in\" button does nothing on phones": "Przycisk „Zaloguj” nie działa na telefonach",
  "Open the site on a phone and tap \"Log in\": nothing happens. On a computer it works.": "Otwórz stronę na telefonie i dotknij „Zaloguj”: nic się nie dzieje. Na komputerze działa.",
  "Add a dark mode": "Dodać tryb ciemny",
  "Several users work in the evening and asked for a dark theme.": "Kilku użytkowników pracuje wieczorami i prosi o ciemny motyw.",
  "Typo on the login page": "Literówka na stronie logowania",
  "\"Montly\" should be \"Monthly\".": "„Miesieczny” powinno być „Miesięczny”.",
  "I will fix it with the next update.": "Poprawię to w następnej aktualizacji.",
  "Exporting the report takes a long time": "Eksport raportu trwa długo",
  "Exporting the monthly report takes about two minutes.": "Eksport raportu miesięcznego trwa około dwóch minut.",
  "How many rows does your report have?": "Ile wierszy ma Twój raport?",
  "The app crashes when an empty form is saved": "Aplikacja się zawiesza przy zapisie pustego formularza",
  "Open a new form, leave all fields empty and click \"Save\".": "Otwórz nowy formularz, zostaw wszystkie pola puste i kliknij „Zapisz”.",
  "Fixed: an empty form now shows a message instead.": "Naprawione: przy pustym formularzu pojawia się teraz komunikat.",
  "Notifications": "Powiadomienia",
  "Mark all as read": "Oznacz wszystkie jako przeczytane",
  "No notifications yet.": "Nie ma jeszcze powiadomień.",
  "Someone": "Ktoś",
  "{user} mentioned you": "{user} wspomniał o Tobie",
  "{user} reported a new issue": "{user} dodał nowe zgłoszenie",
  "{user} assigned the issue to you": "{user} przypisał Ci zgłoszenie",
  "{user} assigned the issue to {handler}": "{user} przypisał zgłoszenie do {handler}",
  "{user} changed the status to {status}": "{user} zmienił status na „{status}”",
  "{user} added a note": "{user} dodał notatkę",
  "{user} changed the priority": "{user} zmienił priorytet",
  "{user} added a relationship": "{user} dodał powiązanie",
  "{user} updated the issue": "{user} zmienił zgłoszenie",
  "{user} mentioned you:": "{user} wspomniał o Tobie:",
  "Bold": "Pogrubienie",
  "bold text": "pogrubiony tekst",
  "Italic": "Kursywa",
  "italic text": "tekst kursywą",
  "Code": "Kod",
  "Link": "Link",
  "Numbered list": "Lista numerowana",
  "Quote": "Cytat",
  "Write": "Pisanie",
  "Preview": "Podgląd",
  "Nothing to preview.": "Brak treści do podglądu.",
  "Copy as Markdown, to show the image in a text": "Skopiuj jako Markdown, aby pokazać obraz w tekście",
  "Git (GitHub, GitLab)": "Git (GitHub, GitLab)",
  "Name, e.g. GitHub app": "Nazwa, np. GitHub app",
  "Create webhook": "Utwórz webhook",
  "Commits that mention #123 add a note to issue 123; \"fixes #123\" (or closes, resolves) also resolves it. Notes are written in the name of the person who creates the webhook.": "Commity, które wspominają #123, dodają notatkę do zgłoszenia 123; „fixes #123” (albo closes, resolves) dodatkowo je rozwiązuje. Notatki są dodawane w imieniu osoby, która utworzyła webhook.",
  "Webhook \"{name}\" created. Copy the address and the secret now — they are shown only once.": "Webhook „{name}” utworzony. Skopiuj adres i sekret teraz — są pokazywane tylko raz.",
  "Payload URL": "Adres (Payload URL)",
  "Secret": "Sekret",
  "GitHub: repository → Settings → Webhooks → Add webhook; content type application/json, the secret as \"Secret\", event \"Just the push event\".": "GitHub: repozytorium → Settings → Webhooks → Add webhook; content type application/json, sekret w polu „Secret”, zdarzenie „Just the push event”.",
  "GitLab: project → Settings → Webhooks; the address as URL, the secret as \"Secret token\", trigger \"Push events\".": "GitLab: projekt → Settings → Webhooks; adres jako URL, sekret jako „Secret token”, wyzwalacz „Push events”.",
  "Notes as": "Notatki jako",
  "Resolve on \"fixes #N\"": "Rozwiązuj przy „fixes #N”",
  "Telegram groups": "Grupy w Telegramie",
  "Connect a group": "Połącz grupę",
  "A connected group gets new issues, changes and public notes of this team.": "Połączona grupa dostaje nowe zgłoszenia, zmiany i publiczne notatki tego zespołu.",
  "Add {bot} to the group, then send this message in the group (valid for an hour):": "Dodaj {bot} do grupy, a potem wyślij w grupie tę wiadomość (ważna przez godzinę):",
  "the bot": "bota",
  "(group without a name)": "(grupa bez nazwy)",
  "Disconnect": "Odłącz",
  "Telegram": "Telegram",
  "Your notifications also come to Telegram.": "Twoje powiadomienia trafiają też do Telegrama.",
  "Get the notifications of the bell in a chat with our Telegram bot.": "Otrzymuj powiadomienia z dzwonka w czacie z naszym botem w Telegramie.",
  "Connect Telegram": "Połącz Telegram",
  "Telegram opens; press \"Start\" in the chat. If it did not open:": "Otworzy się Telegram; naciśnij „Start” w czacie. Jeśli się nie otworzył:",
  "Check again": "Sprawdź ponownie",
  "Notifications stopped.": "Powiadomienia wyłączone.",
  "Hello! Connect your account on the website: My Account → Telegram.": "Cześć! Połącz swoje konto na stronie: Moje konto → Telegram.",
  "This code is not valid any more. Create a new one on the website.": "Ten kod jest już nieważny. Utwórz nowy na stronie.",
  "Open the link from your account page in a private chat with the bot.": "Otwórz link ze strony konta w prywatnym czacie z botem.",
  "Connected: your {app} notifications come here now. Send /stop to end them.": "Połączono: powiadomienia {app} będą teraz przychodzić tutaj. Wyślij /stop, aby je wyłączyć.",
  "Add the bot to a group and send the command there.": "Dodaj bota do grupy i wyślij tam polecenie.",
  "This chat now gets the updates of the team \"{team}\". Send /stop to end them.": "Ten czat dostaje teraz aktualizacje zespołu „{team}”. Wyślij /stop, aby je wyłączyć.",
  "Open the issue": "Otwórz zgłoszenie",
  "Telegram is not set up on this server.": "Telegram nie jest skonfigurowany na tym serwerze.",
  "Terms of Service": "Regulamin",
  "Privacy Policy": "Polityka prywatności",
  "Imprint": "Nota prawna",
  "Not available": "Niedostępne",
  "This page has not been set up yet.": "Ta strona nie została jeszcze skonfigurowana.",
  "By creating an account you agree to the": "Zakładając konto, akceptujesz",
  "and the": "oraz",
  "Site administration": "Administracja serwisu",
  "Users": "Użytkownicy",
  "New in 7 days": "Nowych w 7 dni",
  "New in 30 days": "Nowych w 30 dni",
  "Active in 7 days": "Aktywnych w 7 dni",
  "Files": "Pliki",
  "Owner": "Właściciel",
  "Members": "Członkowie",
  "operator": "operator",
  "not confirmed": "niepotwierdzony",
  "Disable {user}? They are logged out and cannot log in.": "Wyłączyć {user}? Użytkownik zostanie wylogowany i nie będzie mógł się zalogować.",
  "Disable": "Wyłącz",
  "Enable": "Włącz",
  "Site operator access required.": "Wymagany dostęp operatora serwisu.",
  "You cannot disable your own account.": "Nie możesz wyłączyć własnego konta.",
  "Text color": "Kolor tekstu",
  "Underline": "Podkreślenie",
  "Strikethrough": "Przekreślenie",
  "Highlight": "Wyróżnienie",
  "Text size": "Rozmiar tekstu",
  "Small": "Mały",
  "Heading": "Nagłówek",
  "Heading {n}": "Nagłówek {n}",
  "Alignment": "Wyrównanie",
  "Left": "Do lewej",
  "Center": "Do środka",
  "Right": "Do prawej",
  "Justify": "Wyjustuj",
  "Image": "Obraz",
  "Lettered list": "Lista z literami",
  "List item": "Element listy",
  "Table": "Tabela",
  "Horizontal line": "Linia pozioma",
  "More": "Więcej",
  "Subscript": "Indeks dolny",
  "Superscript": "Indeks górny",
  "Code block": "Blok kodu",
  "plain text": "zwykły tekst",
  "How the text is written": "Jak napisany jest tekst",
  "Auto": "Automatycznie",
  "Text": "Tekst",
  "Image preview": "Podgląd obrazu",
  "Preview image": "Wyświetl obraz",
  "Preview {file}": "Wyświetl {file}",
  "Download {file}": "Pobierz {file}",
  "Download": "Pobierz",
  "Previous image": "Poprzedni obraz",
  "Next image": "Następny obraz",
  "Actual size": "Oryginalny rozmiar",
  "Fit to screen": "Dopasuj do ekranu",
  "Loading image…": "Ładowanie obrazu…",
  "Could not load this image. You can still download the file.": "Nie udało się wczytać obrazu. Nadal możesz pobrać plik.",
  "Application updates": "Aktualizacje aplikacji",
  "Fetch the latest main branch, build an isolated release, then restart this application. The page reloads when the new server is ready.": "Pobierz aktualną gałąź main, zbuduj osobne wydanie i uruchom aplikację ponownie. Strona odświeży się, gdy serwer będzie gotowy.",
  "Back up the database before updating. Commit and push local changes before using this button.": "Przed aktualizacją wykonaj kopię bazy danych. Najpierw zapisz lokalne zmiany w commicie i wyślij je do repozytorium.",
  "The update did not finish in time. Check the server update logs before retrying.": "Aktualizacja nie zakończyła się w wyznaczonym czasie. Przed kolejną próbą sprawdź dzienniki aktualizacji serwera.",
  "The application updater must be installed and enabled on this server first.": "Najpierw zainstaluj i włącz usługę aktualizacji aplikacji na tym serwerze.",
  "Application update completed.": "Aktualizacja aplikacji zakończona.",
  "Update requested. Waiting for the updated server; a brief connection interruption is expected.": "Wysłano żądanie aktualizacji. Oczekiwanie na serwer; nastąpi krótka przerwa w połączeniu.",
  "Build and restart the Böning application from origin/main?": "Zbudować i uruchomić ponownie aplikację Böning z origin/main?",
  "Updating…": "Aktualizacja…",
  "Update from Git and restart": "Zaktualizuj z Git i uruchom ponownie",
  "Fetching origin/main and checking the deployment checkout.": "Pobieranie origin/main i sprawdzanie kopii roboczej.",
  "Building the fetched revision in an isolated release directory.": "Budowanie pobranej wersji w osobnym katalogu wydania.",
  "Build succeeded. Restarting the application.": "Budowanie zakończone. Ponowne uruchamianie aplikacji.",
  "Attachment previews": "Podgląd załączników",
  "Maximum preview size": "Maksymalny rozmiar podglądu",
  "Images and video players fit within this size without cropping. Smaller screens limit the width automatically.": "Obrazy i odtwarzacze wideo mieszczą się w tym rozmiarze bez przycinania. Na mniejszych ekranach szerokość jest ograniczana automatycznie.",
  "Example — changes immediately": "Przykład – zmienia się od razu",
  "Example attachment preview": "Przykładowy podgląd załącznika",
  "Performance overview": "Przegląd wydajności",
  "Save your preferences to use this size on issue attachments.": "Zapisz ustawienia, aby używać tego rozmiaru dla załączników w zgłoszeniach.",
  "Preview video": "Podgląd wideo",
  "Play video": "Odtwórz wideo",
  "Play {file}": "Odtwórz {file}",
  "Video preview: {file}": "Podgląd wideo: {file}",
  "Hide video": "Ukryj wideo",
  "This video could not be played in your browser. Download it to watch it in another player.": "Nie można odtworzyć tego wideo w przeglądarce. Pobierz je, aby obejrzeć w innym odtwarzaczu.",
  "Effort & complexity": "Nakład pracy i złożoność",
  "Complexity / Story points": "Złożoność / Story points",
  "Story points": "Story points",
  "Not set": "Nie ustawiono",
  "Not rated": "Bez wyceny",
  "Estimated time": "Szacowany czas",
  "Estimated time (HH:MM)": "Szacowany czas (GG:MM)",
  "Needed time (actual)": "Potrzebny czas (faktyczny)",
  "Needed time (actual, HH:MM)": "Potrzebny czas (faktyczny, GG:MM)",
  "From time entries": "Z wpisów czasu",
  "Manual total": "Suma ręczna",
  "Auto: {time}": "Automatycznie: {time}",
  "Leave blank to use logged time. A manual total replaces it; the two are never added together.": "Pozostaw puste, aby użyć wpisów czasu. Ręczna suma je zastępuje; wartości nigdy nie są dodawane razem.",
  "Story points describe complexity, not hours. Estimates are optional and can change as you learn.": "Story points opisują złożoność, nie godziny. Wyceny są opcjonalne i mogą zmieniać się wraz z nową wiedzą.",
  "Estimation scale and meaning": "Skala wyceny i jej znaczenie",
  "Enter effort as H:MM or decimal hours.": "Podaj czas jako G:MM lub godziny dziesiętne.",
  "Project effort overview": "Przegląd nakładu pracy projektów",
  "Totals include only issues and time entries you can access. Coffee and question-mark estimates are counted separately from numeric points.": "Sumy obejmują tylko dostępne zgłoszenia i wpisy czasu. Kawa i znaki zapytania są liczone oddzielnie od punktów liczbowych.",
  "{count} issues need refinement, research or a planning pause.": "{count} zgłoszeń wymaga doprecyzowania, badań lub przerwy w planowaniu.",
  "No effort": "Bez wysiłku",
  "Already complete or virtually no work.": "Już ukończone lub praktycznie bez pracy.",
  "Very small & trivial": "Bardzo małe i trywialne",
  "A familiar, simple task with no unknowns. A useful reference story.": "Znane, proste zadanie bez niewiadomych. Dobry punkt odniesienia.",
  "Small & routine": "Małe i rutynowe",
  "A little more work, with clear requirements and a familiar solution.": "Nieco więcej pracy, jasne wymagania i znane rozwiązanie.",
  "Medium": "Średnie",
  "A normal, well-defined story with moderate work and a clear approach.": "Zwykła, dobrze określona historia z umiarkowaną pracą i jasnym podejściem.",
  "Large": "Duże",
  "Noticeable effort, with some complexity, unknowns or dependencies.": "Znaczny wysiłek, pewna złożoność, niewiadome lub zależności.",
  "Very large & complex": "Bardzo duże i złożone",
  "Significant complexity or risk. The largest story to plan into one sprint.": "Znaczna złożoność lub ryzyko. Największa historia do zaplanowania w jednym sprincie.",
  "Epic — split before a sprint": "Epic – podziel przed sprintem",
  "Too large or uncertain for one sprint. Break it into smaller stories.": "Zbyt duże lub niepewne na jeden sprint. Podziel na mniejsze historie.",
  "Huge": "Ogromne",
  "A whole feature or module that needs more design and refinement.": "Cała funkcja lub moduł wymagający dalszego projektowania i doprecyzowania.",
  "Huge / incomplete": "Ogromne / niekompletne",
  "A large area of work with fundamental decisions still missing.": "Duży obszar pracy, dla którego brakuje podstawowych decyzji.",
  "Complete unknown": "Całkowita niewiadoma",
  "Start with research or a spike to understand the problem.": "Zacznij od badań lub spike, aby zrozumieć problem.",
  "Break needed": "Potrzebna przerwa",
  "A planning-poker pause. This is not a numeric estimate.": "Przerwa w planning poker. To nie jest wycena liczbowa.",
  "Needs clarification": "Wymaga wyjaśnienia",
  "Requirements or important information are missing. This is not a numeric estimate.": "Brakuje wymagań lub ważnych informacji. To nie jest wycena liczbowa.",
  "Preparing a compatible video preview…": "Przygotowywanie zgodnego podglądu wideo…",
  "Download original": "Pobierz oryginał",
  "Drag to change the order": "Przeciągnij, aby zmienić kolejność",
  "You cannot change the order of notes.": "Nie możesz zmieniać kolejności notatek.",
  "You cannot change the order of attachments.": "Nie możesz zmieniać kolejności załączników.",
  "The target note is not part of this issue.": "Docelowa notatka nie należy do tego zgłoszenia.",
  "Files can only be reordered within the same list.": "Kolejność plików można zmieniać tylko w obrębie tej samej listy.",
  "Calculate from status history (confirmed → resolved)": "Oblicz z historii statusów (potwierdzone → rozwiązane)",
  "Needed time from the status history": "Potrzebny czas z historii statusów",
  "Calendar time": "Czas kalendarzowy",
  "This is how long the issue was open, not the working time. Change it if needed.": "To czas, przez jaki zgłoszenie było otwarte, a nie czas pracy. W razie potrzeby zmień go.",
  "Use this time": "Użyj tego czasu",
  "{days} d {time} h": "{days} d. {time} godz.",
  "{time} h": "{time} godz.",
  "or paste a screenshot, or drop files on the form": "lub wklej zrzut ekranu albo upuść pliki na formularz",
  "Projects overview": "Przegląd projektów",
  "Project activities": "Aktywność projektów",
  "Recent activities": "Ostatnia aktywność",
  "Active target versions": "Aktywne wersje docelowe",
  "Activity in the last": "Aktywność z ostatnich",
  "Added issues": "Dodane zgłoszenia",
  "An issue resolved or closed more than once counts once, at the last time. Story points and needed time belong to the period in which the issue was resolved.": "Zgłoszenie rozwiązane lub zamknięte kilka razy liczy się raz, w ostatnim terminie. Story pointy i potrzebny czas liczą się w okresie, w którym zgłoszenie rozwiązano.",
  "Changes": "Zmiany",
  "Changes in the last {n} weeks": "Zmiany z ostatnich {n} tygodni",
  "Day": "Dzień",
  "Week": "Tydzień",
  "Month": "Miesiąc",
  "Year": "Rok",
  "Finished (resolved)": "Ukończone (rozwiązane)",
  "Tested (closed)": "Przetestowane (zamknięte)",
  "From": "Od",
  "To": "Do",
  "Per": "Na",
  "Period": "Okres",
  "Progress": "Postęp",
  "Involved projects": "Zaangażowane projekty",
  "Involved users": "Zaangażowani użytkownicy",
  "Issues that became closed": "Zgłoszenia, które zostały zamknięte",
  "Issues that became resolved": "Zgłoszenia, które zostały rozwiązane",
  "Last activity": "Ostatnia aktywność",
  "Needed time": "Potrzebny czas",
  "Needed time of the issues resolved in the period": "Potrzebny czas zgłoszeń rozwiązanych w tym okresie",
  "Story points (done / open)": "Story pointy (gotowe / otwarte)",
  "Story points of resolved issues / of open issues": "Story pointy rozwiązanych / otwartych zgłoszeń",
  "Story points of the issues resolved in the period": "Story pointy zgłoszeń rozwiązanych w tym okresie",
  "There are no active target versions.": "Brak aktywnych wersji docelowych.",
  "Week of {date}": "Tydzień od {date}",
  "{done} of {total} resolved ({pct}%)": "{done} z {total} rozwiązanych ({pct}%)",
  "{n} not estimated": "{n} bez oszacowania",
  "The start must be before the end.": "Początek musi być przed końcem.",
  "Too many rows: choose a larger time unit or a shorter range.": "Za dużo wierszy: wybierz większą jednostkę czasu lub krótszy zakres.",
  "{n} weeks": {"one": "{n} tydzień", "few": "{n} tygodnie", "many": "{n} tygodni", "other": "{n} tygodnia"},
  "Note by {user}": "Notatka od {user}",
  "You receive this e-mail because you take part in this issue.": "Otrzymujesz tę wiadomość, ponieważ uczestniczysz w tym zgłoszeniu.",
  "E-mail settings": "Ustawienia e-mail",
  "Planned target versions": "Planowane wersje docelowe",
  "Only issues planned for a target version that is not released yet are counted.": "Liczone są tylko zgłoszenia z wersją docelową, która nie została jeszcze wydana.",
  "Previous page": "Poprzednia strona",
  "Next page": "Następna strona"
};

export default dict;
